import React from 'react'
import { useList } from '@ztechapps/common.hook'
import type { Order as OrderEntity } from '@ztechapps/common.contract'
import { OrderStatus } from '@ztechapps/order.common'
import { useUser } from '../../../hooks/useUser'
import { Order } from '../../../components/Order'
import { myOrderIdListQuery } from '../../../hooks/useOrder/graphql'

export const RecentOrder = () => {
  const { loggedIn } = useUser()

  const { list } = useList<OrderEntity>({
    query: myOrderIdListQuery,
    filter: { status: { $nin: [OrderStatus.inCart.value, OrderStatus.cancelled.value] } },
    sort: { updatedAt: -1 },
    limit: 1,
    options: { queryOptions: { skip: !loggedIn } },
  })

  const recentOrderId = list?.[0]?._id

  return <Order filter={recentOrderId ? { _id: recentOrderId } : undefined} showChat={true} />
}
